<template>
    <div class="bg-white min-vh-100 d-flex flex-column justify-content-end align-items-end">

        <Head title="Bienvenido!!!" />

        <nav class="navbar navbar-expand-lg navbar-dark fixed-top" style="background:#0052a4">
            <div class="container-fluid">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
                    <a class="nav-link m-2 text-white" :href="route('dashboard')" v-if="$page.props.auth">
                        Dashboard - {{ this.$page.props.auth.user.name }}
                    </a>
                    <a class="nav-link m-2 text-white" :href="route('login')" v-else>
                        Administración
                    </a>

                    <a class="nav-link m-2 text-white" :href="route('client-login')" v-if="!$page.props.client">
                        Acceso a clientes
                    </a>
                    <a class="nav-link m-2 text-white" :href="route('client.dashboard')" v-else>
                        Dashboard - {{ this.$page.props.client.business_name }}
                    </a>
                </div>
            </div>
        </nav>


        <div class="container py-5">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="text-center">
                                <img src="/images/logos/2.png" alt="100" width="100">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
